var _mask, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconThreeLinesTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.59479 3.61417L10.6201 15.829C10.9677 16.1767 11.5319 16.1636 11.8796 15.8159C12.2273 15.4682 12.2404 14.9172 11.8862 14.5629L-0.328699 2.34808C-0.676383 2.00039 -1.23399 2.00695 -1.58167 2.35464C-1.92936 2.70232 -1.94248 3.26649 -1.59479 3.61417ZM-3.62186 8.35711L5.90337 17.8823C6.25761 18.2366 6.80866 18.2235 7.15634 17.8758C7.51059 17.5215 7.51715 16.977 7.1629 16.6228L-2.36232 7.09757C-2.71001 6.74989 -3.26761 6.75645 -3.6153 7.10413C-3.95642 7.44526 -3.96954 8.00942 -3.62186 8.35711ZM-5.68172 13.0804L1.18668 19.9488C1.53436 20.2964 2.09853 20.2833 2.44621 19.9356C2.7939 19.5879 2.80046 19.0303 2.45277 18.6827L-4.41562 11.8143C-4.76331 11.4666 -5.32091 11.4731 -5.6686 11.8208C-6.01628 12.1685 -6.0294 12.7327 -5.68172 13.0804Z",
    fill: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.40521 10.6142L17.6201 22.829C17.9677 23.1767 18.5319 23.1636 18.8796 22.8159C19.2273 22.4682 19.2404 21.9172 18.8862 21.5629L6.6713 9.34808C6.32362 9.00039 5.76601 9.00695 5.41833 9.35464C5.07064 9.70232 5.05752 10.2665 5.40521 10.6142ZM3.37814 15.3571L12.9034 24.8823C13.2576 25.2366 13.8087 25.2235 14.1563 24.8758C14.5106 24.5215 14.5171 23.977 14.1629 23.6228L4.63768 14.0976C4.28999 13.7499 3.73239 13.7564 3.3847 14.1041C3.04358 14.4453 3.03046 15.0094 3.37814 15.3571ZM1.31828 20.0804L8.18668 26.9488C8.53436 27.2964 9.09853 27.2833 9.44621 26.9356C9.7939 26.5879 9.80046 26.0303 9.45277 25.6827L2.58438 18.8143C2.23669 18.4666 1.67909 18.4731 1.3314 18.8208C0.983718 19.1685 0.970598 19.7327 1.31828 20.0804Z",
    fill: "#FCFCFC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -5.93555,
    y: 2.09033,
    width: 18.0822,
    height: 19.1125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 1.06445,
    y: 9.09033,
    width: 18.0822,
    height: 19.1125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThreeLinesTriangle);
export default __webpack_public_path__ + "static/media/icon-three-lines-triangle.5ad7077fb77168f15faf47e8eb185a1f.svg";
export { ForwardRef as ReactComponent };